module.exports = __webpack_public_path__ + "img/title2.b48ccaa5.png";